import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46f63a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-muted" }, "1. Enter the restaurant partners' IDs below", -1))
const _hoisted_4 = {
  key: 0,
  class: "count"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control",
          rows: "3",
          placeholder: "Comma delimited RP IDs",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChanged && _ctx.onChanged(...args)))
        }, "\n      ", 544), [
          [_vModelText, _ctx.input]
        ]),
        (_ctx.restCount !== '0')
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.restCount) + " RPs selected", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_5
  ], 64))
}